<template>
  <div class="register">
    <LoginBg :title="'欢迎注册'">
      <div class="register-content">
        <div class="register-main">
          <div class="step">
            <Step :stepNum="stepNum"></Step>
          </div>
          <div class="register-form">
            <div class="step1" v-if="stepNum === 1">
              <div
                class="registerItem center"
                :class="{ checked: chooseNumber === 1 }"
                @click="chooseNumber = 1"
              >
                <div class="mr-20">
                  <img src="@/assets/img/login/gs-icon.png" alt="gs" />
                  <div class="check-label">企业账号</div>
                </div>
                <div class="checkItem">
                  <div class="each-div">{{ $t("register.companyNote1") }}</div>
                  <div class="each-div">{{ $t("register.companyNote2") }}</div>
                  <div class="each-div">{{ $t("register.companyNote3") }}</div>
                  <div class="each-div">{{ $t("register.companyNote4") }}</div>
                </div>
              </div>
              <div
                class="registerItem center"
                :class="{ checked: chooseNumber === 2 }"
                @click="chooseNumber = 2"
              >
                <div class="mr-20">
                  <img src="@/assets/img/login/gr-icon.png" alt="gr" />
                  <div class="check-label">个人账号</div>
                </div>
                <div class="checkItem">
                  <div class="each-div">{{ $t("register.personalNote1") }}</div>
                  <div class="each-div">{{ $t("register.personalNote2") }}</div>
                  <div class="each-div">{{ $t("register.personalNote3") }}</div>
                  <div class="each-div">{{ $t("register.personalNote4") }}</div>
                </div>
              </div>
            </div>
            <RegisterForm
              ref="registerFormRef"
              v-if="stepNum === 2"
              :chooseNumber="chooseNumber"
              @next="registerFormHandle"
            />
            <div class="finishBox" v-if="stepNum === 3">
              <img src="@/assets/img/login/finish-icon.png" alt="finish" />
              <div class="tip">
                {{
                  this.active === 4
                    ? $t("register.auth")
                    : $t("register.completeSuccess")
                }}
              </div>
            </div>
          </div>
          <div class="btn-box">
            <el-button
              v-if="stepNum === 3"
              type="primary"
              class="nextBtn"
              @click="goHome"
            >
              {{
                this.active === 4 ? $t("confirm") : $t("header.homepage")
              }}</el-button
            >
            <el-button
              v-else
              type="primary"
              class="nextBtn"
              :class="{ disabledNextBtn: !chooseNumber }"
              @click="nextStep"
              >{{ $t("register.nextStep") }}</el-button
            >
          </div>
        </div>
      </div>
    </LoginBg>
  </div>
</template>

<script>
import LoginBg from "./components/bg.vue";
import Step from "./components/step.vue";
import RegisterForm from "./components/registerForm.vue";

export default {
  components: { LoginBg, Step, RegisterForm },
  data() {
    return {
      stepNum: 1,
      chooseNumber: null,
      active: null,
    };
  },
  methods: {
    nextStep() {
      if (this.stepNum === 1 && this.chooseNumber) {
        this.stepNum = 2;
      } else if (this.stepNum === 2) {
        this.$refs.registerFormRef.submitForm();
      }
    },
    registerFormHandle(active) {
      this.active = active;
      this.stepNum = 3;
    },
    goHome() {
      this.$router.push({
        name: "home",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.register {
  font-family: AlibabaPuHuiTi;
  .register-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .register-main {
    width: 614px;
    height: 626px;
    border-radius: 16px;
    box-sizing: border-box;
  }
  .step {
    background-color: #ffffff;
    height: 100px;
    border-radius: 16px 16px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .register-form {
    background: #f6f5fa;

    .step1 {
      height: 400px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }
    .registerItem {
      box-sizing: border-box;
      border: 2px solid #f6f5fa;
      padding: 20px;
      border-radius: 8px;
      cursor: pointer;
    }
    .checked {
      background: rgba(42, 84, 209, 0.05);
      border: 2px solid rgba(21, 68, 206, 0.5);
    }
    .check-label {
      margin-top: 8px;
      font-family: AlibabaPuHuiTi;
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      color: #333333;
    }
    .checkItem {
      width: 262px;
      height: 132px;
      border-radius: 8px;
      padding: 14px 20px 14px 16px;
      background: #ffffff;
      box-sizing: border-box;
      border: 1px solid #eef0f2;
    }

    .each-div {
      font-family: AlibabaPuHuiTi;
      font-size: 14px;
      color: #3d3d3d;
      line-height: 26px;
    }
  }
  .btn-box {
    background-color: #ffffff;
    height: 100px;
    border-radius: 0 0 16px 16px;
    display: flex;
    justify-content: center;
    align-items: center;

    .nextBtn {
      width: 162px;
      height: 43px;
      border-radius: 8px;
      background-color: #2a54d1;
      border-color: #2a54d1;
      box-shadow: 0px 4px 10px 0px rgba(116, 183, 255, 0.3);
    }
    .disabledNextBtn {
      background: linear-gradient(
          0deg,
          rgba(255, 255, 255, 0.4),
          rgba(255, 255, 255, 0.4)
        ),
        #2a54d1;
      border: none;
    }
  }
  .finishBox {
    height: 420px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .tip {
      font-size: 24px;
      font-weight: 500;
      text-align: center;
      color: #333333;
      margin-top: 10px;
    }
  }
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mr-20 {
    margin-right: 20px;
  }
  ::v-deep .el-button--primary {
    background-color: #2a54d1;
    border-color: #2a54d1;
  }
  ::v-deep .el-input__inner {
    height: 52px;
    line-height: 52px;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #2a54d1;
  }
}
</style>
